export default __webpack_public_path__ + "static/media/banner.59e0254d.jpg";